var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_vm._v(" "+_vm._s(_vm.timeObj.days - 0)+_vm._s(_vm.langJson('d'))+" : "+_vm._s(_vm.timeObj.hours - 0)+" "+_vm._s(_vm.langJson('h'))+" : "+_vm._s(_vm.timeObj.minutes - 0)+" "+_vm._s(_vm.langJson('m'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }